import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import moment from 'moment'
import 'react-confirm-alert/src/react-confirm-alert.css'
import {PageTitle} from '../../_metronic/layout/core'
import {IHomeworkList, reduxProps} from '../../constants'
import {actionGetHomeworks} from '../../redux/education'
import { HomeworkDetailList } from "./homework-list";

export function HomeworkList() {
  const [activeHomeworkList, setActiveHomeworkList] = useState<IHomeworkList[]>([])
  const [passHomeworkList, setPassHomeworkList] = useState<IHomeworkList[]>([])
  const {classroom, stories} = useSelector((state: reduxProps) => state.educationReducer)

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [retry, setRetry] = useState(0)
  const dispatch = useDispatch()

  useEffect(() => {
    let active = true
    setLoading(true); setError(false)
    setActiveHomeworkList([])
    setPassHomeworkList([])
    let currentDate = moment().utc().toDate()
    dispatch(
      actionGetHomeworks({classroomId: classroom.id}, (r) => {
        if (!active) return
        setLoading(false); setError(r.type !== 'SUCCESS')
        if (r.type === 'SUCCESS') {
          let storyDataList: IHomeworkList[] = []
          for (const item of r.payload.data) {
            const matchStoryItem = stories.find(
              (storyItem: any) => storyItem.storyId === item.storyId
            )
            if (matchStoryItem == null) continue
            storyDataList.push({
              title: matchStoryItem.title,
              homeworkId: item.id,
              storyId: item.storyId,
              coverImageUrl:
                matchStoryItem.basePath +
                '' +
                matchStoryItem.fileProfiles[0]?.filePath +
                '' +
                matchStoryItem?.thumbnail,
              endDate: moment(item.endDate).toDate(),
              startDate: moment(item.startDate).toDate(),
              id: item.id,
            })
          }
          setActiveHomeworkList(storyDataList.filter((item) => item.endDate >= currentDate))
          setPassHomeworkList(storyDataList.filter((item) => item.endDate < currentDate))
        }
      })
    )
    return () => {active = false}
  }, [classroom.id, stories, retry, dispatch])

  return (
    <>
      <PageTitle
        description={'Öğrencilerin atanmış olan sorumluluklarını görüntüleyebilir veya kaldırabilirsiniz'}
      >
        Sorumluluk geçmişi
      </PageTitle>
      {loading ? <div className='edu-data-panel p-8' role='status'>Sorumluluklar yükleniyor…</div> : error ? <div className='alert alert-danger' role='alert'>Sorumluluklar yüklenemedi. <button type='button' className='edu-text-button' onClick={() => setRetry(value => value + 1)}>Tekrar dene</button></div> : <>
      <HomeworkDetailList
        list={activeHomeworkList}
        title={"Aktif Sorumluluklar"}
        emptyDescription={"Şu anda öğrenciler için seçilmiş sorumluluk bulunamadı"}
        description={"Aktif olarak devam eden sorumlulukları görebilirsiniz."}/>

      <div className={"mt-5"}></div>
      <HomeworkDetailList
        list={passHomeworkList}
        title={"Geçmiş Sorumluluklar"}
        emptyDescription={"Günü geçmiş sorumluluk yok"}
        description={"Süresi bitmiş sorumlulukları görebilirsiniz."}/>
      </>}
    </>
  )
}
